/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon20Solid = forwardRef('ArrowDim1VIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.768 1.25a2.5 2.5 0 0 0-3.536 0L4.616 4.866a1.25 1.25 0 1 0 1.768 1.768L8.75 4.268v11.464l-2.366-2.366a1.25 1.25 0 0 0-1.768 1.768l3.616 3.616a2.5 2.5 0 0 0 3.536 0l3.616-3.616a1.25 1.25 0 0 0-1.768-1.768l-2.367 2.367V4.267l2.367 2.367a1.25 1.25 0 0 0 1.768-1.768L11.768 1.25Z" })));
});
